import _extends from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import React from "react";
var __jsx = React.createElement;
import classNames from "classnames";
import { ConsultationDetails } from "../../PatientRecords/ConsultationDetails";
import { EncounterReason } from "../../PatientRecords/EncounterReason";
import { ImagesAndStatus } from "../../PatientRecords/ImagesAndStatus";
import { Labs } from "../../PatientRecords/Labs";
import { AppointmentDateTime } from "../../PatientRecords/components";
import { getDateParts, getStatusBadge, getImagesList } from "../../PatientRecords/utils";
import { useSelectedImage } from "../../PatientRecords/services/useSelectedImage";
import { PatientsContext } from "../../Patients/PatientsContext";
import { useContext } from "react";
import MedicalReportModal from "../../PatientRecords/MedicalReportModal";
import { trackEvent } from "../../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../../utils/mixpanelEvents";
import Modal from "../../common/Modal";
import Loader from "../../Loader";
import { t } from "i18next";
export var EncounterItem = function EncounterItem(_ref) {
  var _encounter$service_re, _encounter$observatio, _encounter$service_re2;
  var encounter = _ref.encounter;
  var _useContext = useContext(PatientsContext),
    currentPatient = _useContext.currentPatient,
    selectedWorkspace = _useContext.selectedWorkspace;
  var workspaceId = selectedWorkspace && selectedWorkspace.value ? Number(selectedWorkspace.value) : undefined;
  var patientId = currentPatient && currentPatient.patient_uid ? Number(currentPatient.patient_uid) : undefined;
  var _useSelectedImage = useSelectedImage(workspaceId, patientId),
    selectedImage = _useSelectedImage.selectedImage,
    setSelectedImage = _useSelectedImage.setSelectedImage,
    isLoadingImage = _useSelectedImage.isLoadingImage,
    handleImageClick = _useSelectedImage.handleImageClick;
  var dateParts = getDateParts(encounter.start_date);
  var hasTests = ((_encounter$service_re = encounter.service_requests) === null || _encounter$service_re === void 0 ? void 0 : _encounter$service_re.length) > 0 || ((_encounter$observatio = encounter.observations) === null || _encounter$observatio === void 0 ? void 0 : _encounter$observatio.length) > 0 || !!encounter.diagnostic_report;
  var statusInfo = getStatusBadge(encounter.status, hasTests);
  var labs = ((_encounter$service_re2 = encounter.service_requests) === null || _encounter$service_re2 === void 0 ? void 0 : _encounter$service_re2.filter(function (sr) {
    var _sr$category_text, _sr$category_text2;
    return ((_sr$category_text = sr.category_text) === null || _sr$category_text === void 0 ? void 0 : _sr$category_text.toLowerCase()) === "laboratory" || ((_sr$category_text2 = sr.category_text) === null || _sr$category_text2 === void 0 ? void 0 : _sr$category_text2.toLowerCase()) === "lab";
  }).map(function (sr) {
    return sr.code_text;
  }).join(", ")) || "-";
  var imagesList = getImagesList(encounter);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("bg-white dark:bg-gray-800 rounded-2xl pt-5 pb-6 px-6 space-y-5 w-full", "border border-teal-500/[0.12] dark:border-teal-300/[0.16]")
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex gap-8"
  }, /*#__PURE__*/React.createElement(AppointmentDateTime, _extends({}, dateParts, {
    classes: "border-none bg-gray-500"
  })), /*#__PURE__*/React.createElement(ConsultationDetails, {
    encounter: encounter
  })), /*#__PURE__*/React.createElement(EncounterReason, {
    reason: (encounter === null || encounter === void 0 ? void 0 : encounter.reason) || []
  }), /*#__PURE__*/React.createElement(Labs, {
    labs: labs
  }), /*#__PURE__*/React.createElement(ImagesAndStatus, {
    imagesList: imagesList,
    handleImageClick: handleImageClick,
    encounter: encounter,
    isLoadingImage: isLoadingImage,
    statusInfo: statusInfo
  }), isLoadingImage && /*#__PURE__*/React.createElement(Modal, {
    show: isLoadingImage,
    onClose: function onClose() {},
    closeOnClickAway: false,
    bgOpacity: true,
    title: /*#__PURE__*/React.createElement("div", {
      className: "text-lg font-semibold"
    }, t("label.loading")),
    className: "flex flex-col w-11/12 sm:w-10/12 lg:w-8/12 xl:w-6/12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center p-6"
  }, /*#__PURE__*/React.createElement(Loader, {
    size: "medium",
    label: t("message.loading_image") || "Loading image..."
  }))), selectedImage && /*#__PURE__*/React.createElement(MedicalReportModal, {
    show: !!selectedImage,
    onClose: function onClose() {
      trackEvent(MIXPANEL_EVENTS.MEDICAL_REPORT_MODAL_CLOSED);
      setSelectedImage(null);
    },
    reportName: selectedImage.name,
    reportContent: selectedImage.htmlContent !== undefined ? selectedImage.htmlContent : selectedImage.url,
    contentType: selectedImage.contentType,
    encounterDate: selectedImage.encounter.start_date,
    provider: selectedImage.encounter.provider || "N/A",
    location: selectedImage.encounter.location || ""
  }));
};